import React, { useEffect, useState } from 'react'
import { Container, FieldBox } from '../../common/formParts/FieldPartsStyled'
import DatePicker, { registerLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import { ScheduleBox } from '../../common/formParts/FieldPartsStyled'
import "react-datepicker/dist/react-datepicker.css";

registerLocale('ja', ja)

const PublishDate = (props) => {
  const [publishNow, setPublishNow] = useState(props.easy_news.publish_now ? "publish_now" : "publish_later")
  //  tomorrow at 9:00 AM
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(9)
  tomorrow.setMinutes(0)

  const [publishDateTime, setPublishDateTime] = useState(
    props.easy_news.publish_datetime ? new Date(props.easy_news.publish_datetime) : tomorrow
  );
  const handleChangePublishNow = (e) => {
    setPublishNow(e.target.value)
    setPublishDateTime(new Date())
  };

  return (
    <Container>
      <div className="field-unit easy_news" key={"easy_news_publish_date"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="easy_news_publish_date">公開設定</label>
        </div>
        <div className="field-unit__field">
          <div id={"easy_news_publish_date"}>
            <FieldBox>
              <input
                type="radio"
                id="publish_now_0"
                value="publish_now"
                onChange={handleChangePublishNow}
                checked={publishNow === "publish_now" || false}
              />
              <label htmlFor="publish_now_0">すぐに公開する</label>
              <input
                type="radio"
                id="publish_now_1"
                value="publish_later"
                onChange={handleChangePublishNow}
                checked={publishNow === "publish_later" || false}
              />
              <label htmlFor="publish_now_1">日時を指定する</label>
              <input type="hidden" name="easy_news[publish_now]" value={publishNow === "publish_now" ? 1 : 0} />
              <input type="hidden" name="easy_news[publish_datetime]" value={publishDateTime} />
            </FieldBox>
            { publishNow === "publish_later" && <FieldBox>
              <ScheduleBox>
                <div className="datetimeLabel">日にち</div>
                <DatePicker
                  name="easy_news[publish_date]"
                  selected={publishDateTime}
                  onChange={(date) => setPublishDateTime(date)}
                  locale="ja"
                  dateFormat='yyyy年M月d日'
                  placeholderText="こちらに入力"
                  className='selectField'
                />
                <div className="datetimeLabel">時刻</div>
                <DatePicker
                  name="easy_news[publish_time]"
                  selected={publishDateTime}
                  onChange={(date) => setPublishDateTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="時刻"
                  dateFormat="h:mm aa"
                  className='selectField'
                />
              </ScheduleBox>
            </FieldBox>
            }
          </div>
        </div>
      </div>
    </Container>
  )
}

export default PublishDate
